<template>
  <v-dialog :value="value" @input="(v) => $emit('input', v)" persistent max-width="1100">
    <v-card class="flight-details-card">
      <div class="booking-title flight-details-title d-flex justify-space-between align-center">
        <span>{{ dialogTitle }}</span>
      </div>

      <v-card-text class="pa-0">
        <div v-for="(f, index) in displayList" :key="index" class="secondary-flight-form">
          <div class="d-flex justify-end px-1 pt-1">
            <v-btn x-small icon @click="deleteRow(f)">
              <v-icon small>clear</v-icon>
            </v-btn>
          </div>

          <div class="flight-main-fields">
            <v-row class="px-1 caption flight-detail-row" dense no-gutters>
              <v-col class="py-0 flight-leg-label" align-self="center">Arrival</v-col>
              <v-col class="py-0">
                <div class="flight-fields">
                  <div class="flight-field">
                    <a-field
                      :config="config.date"
                      :datewall="datewall"
                      :datewallEnd="datewallEnd"
                      v-model="f.arrive_date"
                    />
                  </div>
                  <div class="flight-field">
                    <a-field :config="config.airport" v-model="f.arrive_airport" />
                  </div>
                  <div class="flight-field">
                    <a-field
                      v-if="isInternational"
                      :config="config.flight_num"
                      v-model="f.arrive_flight_num"
                    />
                    <a-field v-else :config="config.flight_num" v-model="f.flight_num" />
                  </div>
                  <div class="flight-field">
                    <a-field :config="config.time" v-model="f.arrive_time" />
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row class="px-1 caption flight-detail-row" dense no-gutters>
              <v-col class="py-0 flight-leg-label" align-self="center">Departure</v-col>
              <v-col class="py-0">
                <div class="flight-fields">
                  <div class="flight-field">
                    <a-field
                      :config="config.date"
                      :datewall="departDateWall(f)"
                      :datewallEnd="datewallEnd"
                      v-model="f.depart_date"
                    />
                  </div>
                  <div class="flight-field">
                    <a-field :config="config.airport" v-model="f.depart_airport" />
                  </div>
                  <div class="flight-field">
                    <a-field
                      v-if="isInternational"
                      :config="config.flight_num"
                      v-model="f.depart_flight_num"
                    />
                    <a-field v-else :config="config.flight_num" v-model="f.flight_num" />
                  </div>
                  <div class="flight-field">
                    <a-field :config="config.time" v-model="f.depart_time" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="px-2 py-2">
          <add-button @click="addRow" />
        </div>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <g-button label="Cancel" @onclick="$emit('input', false)" />
        <g-button type="primary" label="Update" @onclick="eject" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { BookingFields } from "@/config/fields/bookings";
import {
  createEmptyFlight,
  isFlightEmpty,
  normalizeFlight,
  departDateWall as getDepartDateWall,
} from "../flightUtils";

export default {
  props: {
    value: Boolean,
    datewall: [String, Date],
    datewallEnd: [String, Date],
    flightList: Array,
    flightType: String,
  },
  data() {
    return {
      config: BookingFields.flight,
      inputList: [],
    };
  },
  watch: {
    value(v) {
      if (!v) return;
      this.inputList = JSON.parse(JSON.stringify(this.flightList)).map((item) =>
        normalizeFlight(item, this.flightType)
      );
    },
  },
  computed: {
    isInternational() {
      return this.flightType === "INTERNATIONAL";
    },
    dialogTitle() {
      return this.isInternational ? "International Flights" : "Domestic Flights";
    },
    displayList() {
      return this.inputList.filter((item) => {
        if (!item.flight_type && this.flightType === "DOMESTIC") return true;
        return item.flight_type === this.flightType;
      });
    },
  },
  methods: {
    departDateWall(flight) {
      return getDepartDateWall(flight, this.datewall);
    },
    addRow() {
      this.inputList.push(createEmptyFlight(this.flightType));
    },
    deleteRow(flight) {
      const index = this.inputList.indexOf(flight);
      if (index >= 0) this.inputList.splice(index, 1);
    },
    eject() {
      const kept = this.inputList.filter((item) => {
        if (item.flight_type !== this.flightType && !(this.flightType === "DOMESTIC" && !item.flight_type)) {
          return true;
        }
        return !isFlightEmpty(item);
      });
      this.$emit("update", kept);
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss">
@import "../flightDetails.scss";
</style>
